import Vue from 'vue'
import Router from 'vue-router'
import PicksUp from './views/PicksUp.vue'
import Position from './views/Position.vue'
import Credit from './views/Credit.vue'
import PaymentsArchive from './views/PaymentsArchive'
import Account from './views/Account.vue'
import Station from './views/Station.vue'
import Stations from './views/Stations.vue'
import Statistics from './views/Statistics.vue'
import Login from './views/Login.vue'
import ResetPassword from './views/ResetPassword.vue'
import NewAccount from './views/NewAccount.vue'
import AccountConfirmation from './views/AccountConfirmation.vue'
import NewPassword from './views/NewPassword.vue'
import NotFound from './views/NotFound.vue'
import GenericError from './views/GenericError.vue'
import StripeReturn from './views/StripeReturn.vue'
import UpdateRequestedUserInfo from './views/UpdateRequestedUserInfo'
import {ApolloProvider} from "./apollo-provider"
import {getAppBaseUrl,getAppCustomerSelectionUrl} from "./helpers/location"
import _ from "lodash"
import CurrentSharing from "@/views/CurrentSharing.vue";

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                layout: "Login",
                restricted: false,
                redirectIfLogged: "picks-up"
            }
        },
        {
            path: '/reset_password',
            name: 'reset-password',
            component: ResetPassword,
            meta: {
                layout: "login",
                restricted: false,
                redirectIfLogged: "picks-up"
            }
        },
        {
            path: '/new_account',
            name: 'new-account',
            component: NewAccount,
            meta: {
                layout: "login",
                restricted: false,
                redirectIfLogged: "picks-up"
            }
        },
        {
            path: '/',
            redirect: {name: 'picks-up'}
        },
        {
            path: '/picks_up',
            name: 'picks-up',
            component: PicksUp,
            meta: {
                layout: "Application",
                restricted: true
            }
        },
        {
            path: '/stations',
            name: 'stations',
            component: Stations,
            meta: {
                layout: "Application",
                restricted: true
            }

        },
        {
            path: '/stations/:sgid/pickup',
            name: 'station-pickup',
            component: Station,
            meta: {
                layout: "Application",
                restricted: true
            }
        },
        {
            path: '/credit',
            name: 'credit',
            component: Credit,
            meta: {
                layout: "Application",
                restricted: true
            }

        },
        {
            path: "/payments_archive",
            name: "payments-archive",
            component: PaymentsArchive,
            meta: {
                layout: "Application",
                restricted: true
            }
        },
        {
            path: '/position',
            name: 'position',
            component: Position,
            meta: {
                layout: "Application",
                restricted: true
            }

        },
        {
            path: '/account',
            name: 'account',
            component: Account,
            meta: {
                layout: "Application",
                restricted: true
            }

        },
        {
            path: '/statistics',
            name: 'statistics',
            component: Statistics,
            meta: {
                layout: "Application",
                restricted: true
            }

        },
        {
            path: '/confirm_account',
            name: 'confirm-account',
            component: AccountConfirmation,
            meta: {
                layout: "Application",
                restricted: false,
                redirectIfLogged: "picks-up"

            }

        },
        {
            path: "/new_password",
            name: "new-password",
            component: NewPassword,
            meta: {
                layout: "login",
                restricted: false,
                redirectIfLogged: "picks-up"
            }

        },
        {
            path: '/update-your-info',
            name: "update-your-info",
            component: UpdateRequestedUserInfo,
            meta: {
                layout: "Application",
                restricted: true
            }
        },
        {
            path: '/current-sharing',
            name: "current-sharing",
            component: CurrentSharing,
            meta: {
                layout: "Application",
                restricted: true
            }
        },
        {
            path: '/error',
            name: 'generic-error',
            component: GenericError,
            meta: {
                layout: "Application",

            }

        },
        {
            path: '/stripe',
            name: 'stripe-return',
            component: StripeReturn,
            meta: {
                layout: "Application",
            }
        },
        {
            path: '*',
            name: 'not-found-error',
            component: NotFound,
            meta: {
                layout: "Application",
            }

        }
    ]
})


router.beforeEach((to, from, next) => {

    const domain = _.trim(window.location.hostname)
    const clientApollo = ApolloProvider.clients.clientPublic

    if (domain !== process.env.VUE_APP_NO_CUSTOMER_PUBLIC_DOMAIN) {

        clientApollo.query(
            {
                query: require("./graphql/queries/cities.gql")

            }).then(result => {
            const customers = result.data.customers.nodes
            const customer_domains = _.map(customers, (el) => {
                return _.trim(el.pwaDomain)
            })


            if (_.includes(customer_domains, domain)) {

                next()
            } else {

                window.location = getAppCustomerSelectionUrl()
            }

        });
    }else{
        next()
    }


});


router.beforeEach((to, from, next) => {

    const restricted = to.meta.restricted
    const redirectIfLogged = to.meta.redirectIfLogged

    if (restricted === true && redirectIfLogged) {
        getCurrentUser().then(() => {
            next({name: redirectIfLogged})
        }).catch((error) => {
            catch401(error, {name: "login"}, next)
        })

    } else if (restricted === true && !redirectIfLogged) {
        getCurrentUser().then((result) => {
            const user = result.data.user
            const address = user.residenceAddress
            const number = user.residenceNumber
            const cap = user.residenceCap
            const city = user.residenceCity
            const district = user.residenceDistrict
            const country = user.residenceCountry

            if(to.name !== "update-your-info") {
                if (address && address !== "" && number && number !== "" &&
                    cap && cap !== "" && city && city !== "" && district &&
                    district !== "" && country && country !== "") {
                    next()
                } else {
                    next({name: "update-your-info"})
                }
            } else {
                next()
            }



        }).catch((error) => {
            catch401(error, {name: "login"}, next)
        })

    } else if (!restricted && redirectIfLogged) {
        getCurrentUser().then(() => {
            next({name: redirectIfLogged})
        }).catch((error) => {
            catch401(error, null, next)

        })

    } else {
        next()
    }

})


router.onError(() => {
    //TODO catch errore rotte
    console.log("errore")

})


async function getCurrentUser() {

    const clientApollo = ApolloProvider.clients.clientPrivate

    const result = await clientApollo.query(
        {
            query: require("./graphql/queries/currentUser.gql"),
            fetchPolicy: 'network-only'

        })

    return result
}

function catch401(error, routeObjIfError = null, next) {
    if (error.networkError && error.networkError.response.status === 401) {
        if (routeObjIfError)
            next(routeObjIfError)
        else
            next()
    } else {
        throw(error)
    }

}

export default router